export default __webpack_public_path__ + "static/media/hannah-port.e9686461.jpg";